import { render } from "./ToastComponent.vue?vue&type=template&id=38c89246"
import script from "./ToastComponent.vue?vue&type=script&lang=js"
export * from "./ToastComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__